import { types } from "mobx-state-tree";

const EventModel = types.model(`event`, {
    scheduleId: types.maybeNull(types.string),
    scheduleLinkId: types.maybeNull(types.string),
    startDateTime: types.number,
    cron: types.maybeNull(types.string),
    action: types.maybeNull(types.string)
});

const CalendarModel = types
    .model(`calendar`, {
        calendarView: types.string,
        calendarDate: types.maybeNull(types.Date)
    })
    .actions((self) => ({
        setCalendarDate(newDate: Date) {
            self.calendarDate = newDate;
        }
    }));

const ScheduleModel = types.model(`schedule`, {
    title: types.maybeNull(types.string),
    expireDateTime: types.maybeNull(types.number),
    timezone: types.maybeNull(types.string),
    isScheduleRunning: types.maybeNull(types.boolean),
    status: types.maybeNull(types.string),
    on: types.maybeNull(EventModel),
    off: types.maybeNull(EventModel)
});

const ScheduleStore = types.model(`ScheduleStore`, {
    schedule: ScheduleModel,
    calendar: CalendarModel
});

export default ScheduleStore;
